// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"925":"d9e526c0","945":"67db40d0","965":"6b341b83","999":"7ddf8e74"}[chunkId] + ".chunk.js";
};